import { useMemo } from 'react';

const getDisplayName = (assignment) => {
    return assignment?.displayName || assignment?.data?.displayName || assignment?.assignment?.displayName || '';
};

const hasStoryInstruction = (assignment) => {
    return (typeof assignment?.storyInstruction === 'string' && assignment.storyInstruction.length > 0) ||
        (typeof assignment?.data?.storyInstruction === 'string' && assignment.data.storyInstruction.length > 0) ||
        (typeof assignment?.assignment?.storyInstruction === 'string' && assignment.assignment.storyInstruction.length > 0);
};

const hasArticleLevel = (assignment) => {
    return (typeof assignment?.article_level_id === 'string' && assignment.article_level_id.length > 0) ||
        (typeof assignment?.data?.article_level_id === 'string' && assignment.data.article_level_id.length > 0) ||
        (typeof assignment?.assignment?.article_level_id === 'string' && assignment.assignment.article_level_id.length > 0);
};

const isWorksheetAssignment = (assignment) => {
    return assignment?.type === 'worksheet' ||
        assignment?.typeId === 'worksheet' ||
        assignment?.assignmentType === 'worksheet' ||
        assignment?.data?.type === 'worksheet' ||
        assignment?.data?.typeId === 'worksheet' ||
        assignment?.data?.assignmentType === 'worksheet' ||
        assignment?.assignment?.type === 'worksheet' ||
        assignment?.assignment?.typeId === 'worksheet' ||
        assignment?.assignment?.assignmentType === 'worksheet';
};

export const useAssignmentCoverTitle = ({ assignment, title }) => {
    return useMemo(() => {
        const shouldShowTitle =  hasStoryInstruction(assignment) || hasArticleLevel(assignment) || isWorksheetAssignment(assignment);
        if (!shouldShowTitle) {
            return '';
        }
        return typeof title === 'string' ? title : getDisplayName(assignment);
    }, [assignment, title]);
};

